module.exports = __webpack_public_path__ + "img/37.bc0718c4.png";